import { useCallback } from "react";
import { useAuthorizedFetch } from "../http/useAuthorizedFetch";

const API = "https://pwa-server.test/api/v1";

// function parseBody(response) {
//   const ct = response.headers.get("content-type") || "";
//   if (ct.includes("application/json")) return response.json();
//   return response.text();
// }

// async function fetchWithCreds(url, options = {}) {
//   // If you use a CSRF cookie for POSTs, include it here:
//   // const csrf = typeof getCookie === "function" ? getCookie("csrf_token") : null;

//   const headers = {
//     Accept: "application/json",
//     // ...(csrf ? { "X-CSRF-Token": csrf } : {}),
//     ...(options.headers || {}),
//   };

//   return fetch(url, {
//     credentials: "include", // send cookies on every request
//     ...options,
//     headers,
//   });
// }

/**
 * Test GET with optional one-time refresh
 * @param {boolean} retry - whether to try one refresh+retry on 401/403
 * @returns {Promise<{ok: boolean, status: number, data: any}>}
 */

export const useTestGet = () => {
  console.log("testGet");
  const fetchWithAuth = useAuthorizedFetch();

  const testGet = useCallback(async () => {
    // const testGet = async () => {
    try {
      // Step 1: initial call (disable auto auth-retry to keep manual flow)
      let response = await fetchWithAuth(`${API}/tests/tokens`, {
        method: "GET",
        retryOnFail: true,
      });
      // console.log(await response.json());
      // Normal success
      return response; //{ success: response.ok, message: "", data: {} };
    } catch (err) {
      return {
        success: false,
        message: String(err?.message || err),
        data: {},
      };
    }
    // };
  }, []);

  return testGet;
};

// export default useTestGet;

/*

export function useTestGet(retry = true) {
  const fetchWithAuth = useAuthorizedFetch();
  const { isLoggedIn } = useContext(AuthContext);
  try {
    let res = await fetchWithCreds(`${API}/tests/tokens`, { method: "GET" });

    if ((res.status === 401 || res.status === 403) && retry) {
      console.log("tests/tokens status:", res.status);

      // Attempt refresh
      const refreshRes = await fetchWithCreds(`${API}/auth/refresh`, {
        method: "POST",
      });
      console.log("refresh status:", refreshRes.status);

      if (!refreshRes.ok) {
        return {
          ok: false,
          status: refreshRes.status,
          data: await parseBody(refreshRes).catch(() => null),
        };
      }

      // Retry original
      res = await fetchWithCreds(`${API}/tests/tokens`, { method: "GET" });
      console.log("retry tests/tokens status:", res.status);
    }

    const data = await parseBody(res).catch(() => null);
    return { ok: res.ok, status: res.status, data };
  } catch (err) {
    return { ok: false, status: 0, data: String(err?.message || err) };
  }
}

// import { getCookie } from "../../utils/Cookie";

/**
 *  Update Refresh Token
 * @returns boolean
 *
export async function testGet(retry = true) {
  let response = null;

  try {
    response = await fetch("https://pwa-server.test/api/v1/tests/tokens", {
      method: "GET",
    });

    if ((response.status === 401 || response.status === 403) && retry) {
      console.log(response.status);
      // Try refreshing the token once
      const r = await fetch("https://pwa-server.test/api/v1/auth/refresh", {
        method: "POST",
        credentials: "include",
      });

      console.log("refresh: " + r.status);
      if (!r.ok) {
        /* refresh failed → force login *
        return r;
      } else {
        // Retry the original request
        response = await fetch("https://pwa-server.test/api/v1/tests/tokens", {
          method: "GET",
        });
        console.log("2nd: " + r.status);
      }
    } else {
      //   logout();
      return response;
    }

    return response.json();
  } catch {
    return response.text();
  }
}

*/
